app.controller('popupReferralToClinicController', ['$scope', '$rootScope', '$state', '$mdDialog', 'visitCardData', 'referralToClinicModel', 'dictionaryModel',
    function ($scope, $rootScope, $state, $mdDialog, visitCardData, referralToClinicModel, dictionaryModel) {

        function setData() {
            $scope.referralToClinicData = new ReferralToClinicVO();
            $scope.referralToClinicForm = null;

            $scope.referralToClinicData.visitCardId = visitCardData.visitCard.id;
            $scope.referralToClinicData.treatmentInSpecializedFacility = true;
            $scope.referralToClinicData.hospitalReferral = true;

            $scope.textareaPlaceholder = 'Max 500 znaków';
            $scope.formFirstCheck = false;
            $scope.specializedFacilityList = [];
        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on(Event.DICTIONARY.GET_DICTIONARY_ELEMENT_DATA_PAGE.SUCCESS, function (event, dataPage, code) {
                if(code === Constant.DICTIONARY_CODE.SPECIALIZED_FACILITY) {
                    $scope.specializedFacilityList = dataPage.data;
                    console.log($scope.specializedFacilityList);
                }
            });

            $scope.$on(Event.REFERRAL_TO_CLINIC.SAVE.SUCCESS, function(event, data) {
                $scope.cancel();
                setTimeout(function() {
                    $rootScope.$broadcast(Event.NOTIFICATION, new NotificationVO(Enum.NOTIFICATION_TYPE.SUCCESS, 'T.MEEDY.SYSTEM.NOTIFICATION.OPERATION_SUCCEEDED'));
                }, 500);
            });

        }

        function setActions() {
            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.save = function () {
                $scope.referralToClinicForm.$setSubmitted();
                if ($scope.referralToClinicForm.$valid || $scope.formFirstCheck) {
                    referralToClinicModel.save($scope.referralToClinicData);
                } else {
                    $scope.formFirstCheck = true;
                }
            };

        }


        function configureInterface() {

        }

        function initialize() {
            dictionaryModel.getDictionaryElementsDataPage(Constant.DICTIONARY_CODE.SPECIALIZED_FACILITY, {});
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
